// MANAGER-OPS-003 — Store V2 customer order actions (post-checkout).
// Same-origin Pages Function only. No live payment. Staging only.
import { storeV2AuthHeaders } from "./store-v2-auth-headers-v2.js";

const CUSTOMER_ACTION_URL = "/api/store-v2/customer-action";

export type CustomerOrderActionKind =
  | "payment_reported"
  | "change_payment_method"
  | "abandon_payment"
  | "manager_help"
  | "payment_receipt_requested"
  | "send_fop_requisites"
  | "send_novapay_payment_link";

export interface CustomerOrderActionResult {
  ok: boolean;
  action?: string;
  paymentStatus?: string;
  paymentMethod?: string;
  error?: string;
  message?: string;
  delivery_state?: string;
  telegram_message_id?: number | null;
  payment_url?: string | null;
  payment_id?: string | null;
  duplicate?: boolean;
}

export async function customerOrderActionV2(input: {
  sessionKey: string;
  orderId: string;
  action: CustomerOrderActionKind;
  paymentMethod?: string | null;
  paymentComment?: string | null;
  paymentUrl?: string | null;
  hasReceipt?: boolean;
  /** RC7 — required when NovaPay provider is still processing. */
  confirmProcessingAbandon?: boolean;
  /** 168A-R1 — controlled Telegram payment-link resend after soft window. */
  forceResend?: boolean;
}): Promise<CustomerOrderActionResult> {
  let res: Response;
  try {
    res = await fetch(CUSTOMER_ACTION_URL, {
      method: "POST",
      headers: storeV2AuthHeaders({ "Content-Type": "application/json" }),
      body: JSON.stringify({
        session_key: input.sessionKey,
        order_id: input.orderId,
        action: input.action,
        payment_method: input.paymentMethod ?? null,
        payment_comment: input.paymentComment ?? null,
        payment_url: input.paymentUrl ?? null,
        has_receipt: input.hasReceipt === true,
        confirm_processing_abandon: input.confirmProcessingAbandon === true,
        force_resend: input.forceResend === true,
      }),
    });
  } catch {
    return { ok: false, error: "network", message: "Немає звʼязку. Спробуйте ще раз." };
  }
  let json: Record<string, unknown> = {};
  try {
    json = (await res.json()) as Record<string, unknown>;
  } catch {
    /* non-JSON */
  }
  if (!res.ok || json.ok === false) {
    const failed: CustomerOrderActionResult = {
      ok: false,
      error: String(json.error ?? `http_${res.status}`),
    };
  if (typeof json.message === "string") failed.message = json.message;
  else if (typeof json.message_uk === "string") failed.message = json.message_uk;
  return failed;
  }
  const result: CustomerOrderActionResult = { ok: true };
  if (json.action) result.action = String(json.action);
  if (json.payment_status) result.paymentStatus = String(json.payment_status);
  if (json.payment_method) result.paymentMethod = String(json.payment_method);
  if (typeof json.message_uk === "string") result.message = json.message_uk;
  else if (typeof json.message === "string") result.message = json.message;
  if (typeof json.delivery_state === "string") result.delivery_state = json.delivery_state;
  if (json.telegram_message_id != null) result.telegram_message_id = Number(json.telegram_message_id);
  if (typeof json.payment_url === "string") result.payment_url = json.payment_url;
  if (typeof json.payment_id === "string") result.payment_id = json.payment_id;
  if (json.duplicate === true) result.duplicate = true;
  return result;
}
